module.exports = __webpack_public_path__ + "media/new/pay-guarda-38dcd71d.svg";